import { Injectable, inject, ViewChild } from '@angular/core';
import { child, Database, equalTo, listVal, objectVal, onValue, orderByChild, push, query, ref, remove, update } from '@angular/fire/database';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Storage, ref as refStorage, getDownloadURL, listAll, uploadBytes, deleteObject, uploadBytesResumable  } from '@angular/fire/storage';
import { getStorage, ref as refFS } from "firebase/storage";
import moment from 'moment';
import { tap, take, map, catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportesService {
  private http = inject(HttpClient);
  private database: Database = inject(Database);
  private storage = inject(Storage);

  obtenerConsulta(oData: any) {
    return this.http.post(environment.reportes.consulta, oData);
  }
  
  obtenerDescarga(oData: any) {
    return this.http.get(environment.reportes.descarga, {
      params: { 
        tipo: oData.tipo,
        fechaInicio: oData.fechaInicio,
        fechaFin: oData.fechaFin
      },
      headers: { "Content-Type": "application/json" },
      responseType: "arraybuffer",
    }).pipe(
      tap((data) => console.log("API Response", data)),
      take(1),
      map((data: any) => {
        return data;
      }),
      catchError((error: any) => {
        return of({
          error: true,
          message: "No se encontrarón datos para esta consulta.",
        } as unknown as any);
      })
    );
  }
}